<template>
  <VDropdown
    theme="productVariants"
    :shown="!hideVariants"
    placement="bottom"
    @apply-hide="onHide"
  >
    <div
      class="row bg-white shadow-lg rounded-pill p-2 flex items-center text-left variant-select"
      role="button"
      @click="
        () => {
          hideVariants = false
        }
      "
    >
      <div class="col-9">
        <p class="m-0">
          {{ t('other_variants') }}
        </p>
      </div>
      <div class="col-3 text-right">
        <i class="mi-bars icon-28" />
      </div>
    </div>
    <template #popper>
      <div class="variants-dropdown">
        <ul
          class="list-unstyled m-0 py-2 justify-center row"
          role="list"
        >
          <li
            v-for="product in products"
            :key="product.id"
            class="flex px-1 relative col-12 item-show"
          >
            <div class="row flex-grow-1 items-center item">
              <div class="col-3 px-1">
                <div class="mb-0 flex-grow-1">
                  <RemoteResponsiveImage
                    :product-image-data="product.images[0]?.data"
                    img-class="w-100 h-auto image-cover"
                    :alt="product.name"
                    sizes="25vw"
                  />
                </div>
              </div>
              <div class="col-6 px-1">
                <router-link
                  class="block p-1 text-sm flex-grow-1 leading-sm stretched-link"
                  :to="{ name: 'productPath', params: { permalink: product.permalink } }"
                >
                  <span class="block">{{ product.name }}</span>
                </router-link>
              </div>
              <div class="col-3 px-1">
                <strong class="text-sm">
                  <span v-if="product.quantityDiscounts">{{ t('from') }}
                    {{
                      numberToCurrency(
                        product.quantityDiscounts[product.quantityDiscounts.length - 1].price,
                        product.currency,
                      )
                    }}</span>
                  <span v-else>{{ numberToCurrency(product.price, product.currency) }}</span>
                </strong>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </VDropdown>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'
import { numberToCurrency } from '@/mixins/numberToCurrency'

const hideVariants = ref(true)

const onHide = (value) => {
  hideVariants.value = value
}

window.addEventListener('scroll', () => {
  onHide(true)
})

const { t } = useI18n()

defineProps({
  products: {
    type: Array,
    default: () => {},
  },
})
</script>

<style lang="scss" scoped>
.variant-select {
  width: 398px;
  @media screen and (max-width: 991px) {
    width: 100%;
  }
}

.variants-dropdown {
  max-height: 320px;
  width: 100%;
}
</style>

<i18n>
  {
    "cs": {
    "from": "Od",
    "other_variants": "Další varianty"
},
    "sk": {
    "from": "Od",
    "other_variants": "Ďalšie varianty"
},
    "pl": {
    "from": "Od",
    "other_variants": "Inne warianty"
},
    "hu": {
    "from": "Ft-tól",
    "other_variants": "Egyéb változatok"
},
    "de": {
    "from": "Ab",
    "other_variants": "Andere Varianten"
},
    "at": {
    "from": "Ab",
    "other_variants": "Andere Varianten"
},
    "ro": {
    "from": "De la",
    "other_variants": "Alte variante"
},
    "fr": {
    "from": "À partir de",
    "other_variants": "Autres variantes"
},
    "it": {
    "from": "Da",
    "other_variants": "Altre varianti"
}
  }
</i18n>
